export default __webpack_public_path__ + "0ce6ea08642ab2649a629876cd1a0557.png";